import { takeLatest, fork, put, all, call } from 'redux-saga/effects'

import i18n from 'i18n'
import { candidateData } from './slice'
import { userAPI } from 'features/users/api'
import { RequestUtils } from 'utils'

function* getData({ payload: { id, params = {} } }) {
  try {
    let requestParams = {
      includes: ['avatar', 'studentProfile'],
    }

    requestParams = RequestUtils.getMapRequestParams(params, requestParams)

    const response = yield call(userAPI.getPublicUser, id, requestParams)

    const { data } = response

    yield put(candidateData.getDataSuccess(data))
  } catch (error) {
    const message = error.response?.data?.message || i18n.t('error')
    yield put(candidateData.getDataError(message))
  }
}

function* watchGetData() {
  yield takeLatest(candidateData.getData, getData)
}

export function* dataSaga() {
  yield all([fork(watchGetData)])
}
